import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import * as WaveSurfer from 'wavesurfer.js';
import * as TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js';
import * as RegionsPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions.js';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { Wave } from "../models/wave-list.model";
import { Regions } from '../models/region.model';
import { AuthService } from '../auth/auth.service';
import { WaveService } from '../services/wave-list-service';
import { RegionService } from '../services/region.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { AudioRecordingService } from "../services/recorder.service";
import { AudioService } from "../services/audio.service";

@Component({
	selector: 'app-wave-viewer',
	templateUrl: './wave-recorder.component.html',
	styleUrls: ['./wave-recorder.component.css']
})
export class WaveRecorderComponent implements OnInit {

	userName;
	subscription: Subscription;
	private waveSub: Subscription;
	text: any = [];
	curWaveName = "";
	fileChosen = false;
	textFileType = "ooTextFile";
	textFileClass = "TextGrid";
	textGridClass = "IntervalTier";
	textGridName = "Sentence";
	textGridCount;
	eventId = null;
	isMenuOpen = false;
	isLast = false;
	status: string = "";
	event: any;
	curTextFileCont;
	curScroll;
	isLoaded = false;
	regions: Array<Regions>;
	curWavevalue
	// Initializing id & start second for creating regions in wavesurfer instance
	soundSeconds = 0;
	timeline;
	regionId: number = 1;
	startSecond: number = 0;
	clickSecond: number = 0;
	regionColor1 = "rgba(0,255,0,0.3)";
	regionColor2 = "rgba(255, 0, 0, 0.2)";
	regionColor = this.regionColor1;
	text_segment_id = "";
	audioFile;
	public wavesurfer: WaveSurfer;
	textElementId;
	isPlaying = false;
	regionsCount: number;
	regionTextArray: string[] = [];
	value = "horizontal";
	fileList = "";
	userIsAuthenticated = false;
	isAdmin;
	private authListenerSubs: Subscription;
	audioCount = 0;
	audioCountChange = new EventEmitter<Number>();
	previousAudios = false;
	nextAudios = false;
	previousAudioChange = new EventEmitter<boolean>();
	nextAudioChange = new EventEmitter<boolean>();
	curWaveNameChange = new EventEmitter<any>();
	// color = 'white';

	// Audio Recording related
	isRecording = false;
	recordedTime = 0;
	blobUrl;
	audio = new Audio();
	audioData;
	audioSource;
	recordingStatus;
	public currentRegion: any = null;
	public selectedRegion = false;


	constructor(private route: ActivatedRoute, private http: HttpClient, private rService: RegionService, public waveService: WaveService, public authService: AuthService, private router: Router, private _snackBar: MatSnackBar, private audioRecordingService: AudioRecordingService, private audioService: AudioService, private sanitizer: DomSanitizer) {

		// Recording Service related subscriptions
		this.audioRecordingService.recordingFailed().subscribe(() => {
			this.isRecording = false;
		});

		this.audioRecordingService.getRecordedTime().subscribe((time) => {
			this.recordedTime = time;
		});

		this.audioRecordingService.getRecordedBlob().subscribe((data) => {
			this.audioData = data;
			this.audioSource = URL.createObjectURL(data.blob);
			this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
			console.log(this.audioSource)
			this.loadAudio(this.audioSource, "RECORDED");
			this.isLoaded = true;
		});

	}

	// Recording Service related functions

	startRecording() {
		if (!this.isRecording) {
			this.isRecording = true;
			this.audioRecordingService.startRecording();
		}
	}

	stopRecording() {
		if (this.isRecording) {
			this.isRecording = false;
			this.audioRecordingService.stopRecording(this.curWaveName);
		}
	}

	clearRecordedData() {
		this.blobUrl = null;
	}

	playPause() {
		// console.log("this.isPlaying: ", this.isPlaying);
		// this.audio.src = this.audioSource;
		// let myInterval;

		// Toggle play state
		if (this.isPlaying) {
			this.wavesurfer.pause();
			this.isPlaying = false;
			$("#playPause").html("<i class='glyphicon glyphicon-play'></i>");
			console.log('Paused → isPlaying =', this.isPlaying);
		} else {
			this.wavesurfer.play();
			this.isPlaying = true;
			console.log('Playing → isPlaying =', this.isPlaying);
			$("#playPause").html("<i class='glyphicon glyphicon-pause'></i>");
		}

		// if (this.isPlaying == false) {
		// 	this.audio.load();
		// 	this.audio.play();
		// 	this.isPlaying = true;
		// 	// console.log("set isPlaying true inside playPause firt if condition");
		// 	$("#playPause").html("<i class='glyphicon glyphicon-pause'></i>");
		// 	console.log("audio.currentTime:", this.audio.currentTime);
		// 	let audioDuration = this.recordedTime;
		// 	// console.log("audioDuration:", audioDuration);
		// 	myInterval = setInterval(() => {
		// 		if ((parseFloat(this.audio.currentTime.toFixed(2)) >= audioDuration)) {
		// 			setTimeout(() => {
		// 				this.audio.pause();
		// 				this.isPlaying = false;
		// 				// console.log("set isPlaying false inside myInterval on auto pause");
		// 				$("#playPause").html("<i class='glyphicon glyphicon-play'></i>");
		// 			}, 500)
		// 			clearInterval(myInterval);
		// 		}
		// 	}, 1000);
		// }
		// else if (this.isPlaying == true) {
		// 	$("#playPause").html("<i class='glyphicon glyphicon-play'></i> ");
		// 	this.isPlaying = false;
		// 	// console.log("set isPlaying false inside else if condition");
		// 	clearInterval(myInterval);
		// 	this.audio.pause();
		// }
	}

	saveAudio() {
		this.audioData.recordedTime = this.recordedTime
		this.audioService.sendAudio(this.audioData, $("#text").val()).then(result => {
			console.log("result:", result);
			this.openSnackBar(result.message + " - " + this.text[0].recordingId, "", 4000);
			this.text[0].edited = true;
			if (Boolean(result.ok) == true) {
				this.text[0].status = "recorded";
				this.recordingStatus = "RECORDED";
				this.text[0].audioDuration = this.recordedTime;
			}
		})
	}

	ngOnDestroy() {
		this.stopRecording();
		this.authListenerSubs.unsubscribe();
	}

	ngOnInit(): void {
		this.userName = this.authService.getUserName();

		this.waveService.getServerWaves(this.userName, this.audioCount).then((response: any) => {
			this.displayWavFiles(response);
		});

		this.userIsAuthenticated = this.authService.getIsAuth();
		// console.log("this.userIsAuthenticated", this.userIsAuthenticated)
		this.userName = this.authService.getUserName();
		// console.log("this.userName", this.userName);
		this.isAdmin = this.authService.getIsAdmin();
		// console.log("this.isAdmin" + this.isAdmin);
		this.authListenerSubs = this.authService
			.getAuthStatusListener()
			.subscribe(isAuthenticated => {
				this.userIsAuthenticated = isAuthenticated;
				this.userName = this.authService.getUserName();
				this.isAdmin = this.authService.getIsAdmin();
			});


		// we are creating waveform holder
		this.wavesurfer = WaveSurfer.create({
			height: 170,
			container: '#waveform',
			scrollParent: false,
			waveColor: '#3fb0ac',
			progressColor: '#547980',
			fillParent: true,  //<-- Initially to fill wave full width
			plugins: [
				TimelinePlugin.create({
					container: "#waveform-timeline"
				}),
				RegionsPlugin.create({
					dragSelection: {
						slop: 5
					}
				})
			],
			backend: 'WebAudio'
		});

		this.wavesurfer.on('finish', () => {
			this.isPlaying = false;
			$("#playPause").html("<i class='glyphicon glyphicon-play'></i>");
			console.log('Audio finished → isPlaying =', this.isPlaying);
		});
		// Listen for region events
		this.wavesurfer.on('region-created', (region) => {
			// remove previous region if you want only one region at a time
			if (this.currentRegion && this.currentRegion.id !== region.id) {
				try { this.currentRegion.remove(); } catch (e) { }
			}
			this.currentRegion = region;
			this.selectedRegion = true;

			// optional: highlight or store region metadata
			region.on('update-end', () => {
				// region.start and region.end updated
			});

			// clicking region selects it (prevents play)
			region.on('click', (e) => {
				e.stopPropagation();
				// keep selected
			});
		});

		this.wavesurfer.on('region-removed', (region) => {
			if (this.currentRegion && region.id === this.currentRegion.id) {
				this.currentRegion = null;
				this.selectedRegion = false;
			}
		});

		this.wavesurfer.on('error', (status) => {
			this.status = status.name;
			console.log("load error status:", status);
			if (this.status.indexOf("AbortError") == -1) {
				//console.log("this.status: "+this.status);
				// this.removeRegions();
				this.isLoaded = false;
				$("#waveform").css("display", "none");
				$("#waveform-timeline").css("display", "none");
			}

		});

		this.wavesurfer.on("loading", function (progress) {
			console.log("loading audio in wavesurfer");
		});

		this.wavesurfer.on('ready', () => {
			console.log("-------- inside on ready -------");
			this.soundSeconds = this.wavesurfer.getDuration();
			this.soundSeconds = +this.soundSeconds.toFixed(3);
			this.startSecond = +this.startSecond.toFixed(3);
			console.log("this.startSecond", this.startSecond, "this.soundSeconds", this.soundSeconds);

			// this.createExistRegions();

			//creating text field before creating any regions

			this.wavesurfer.params.minPxPerSec = 50;
			var minPxPerSec = this.wavesurfer.params.minPxPerSec;

			var totalPixels = $("#waveform").innerWidth();
			var pxPerSec = totalPixels / this.soundSeconds;
			pxPerSec = +pxPerSec.toFixed(3);
			this.wavesurfer.zoom(pxPerSec);
			$('#textgrid-resize').css("width", (totalPixels) + "px");

			$('#slider').attr("min", pxPerSec);
			$('#slider').val(pxPerSec);
			$("#waveform").children("wave").css("border-style", "groove");
		});

		this.wavesurfer.on('zoom', (pxPerSec) => {
			var onZoom = this.soundSeconds * pxPerSec;
			onZoom = +onZoom.toFixed(3);
			$('#textgrid-resize').css("width", (onZoom) + "px");
		});

		this.wavesurfer.on('scroll', (scrollEvent) => {
			var scroll = scrollEvent.target.scrollLeft;
			this.curScroll = scroll;
			var elems = $('.textgrid-segment');
			var len = elems.length;
			for (var i = 0; i < len; i++) {
				$("#" + elems[i].id).css("left", -scroll);
			}
		});

		$(window).resize(() => {
			var totalPixels = $("#waveform").innerWidth();
			var pxPerSec = totalPixels / this.soundSeconds;
			pxPerSec = +pxPerSec.toFixed(3);
			this.wavesurfer.zoom(pxPerSec);
			$('#textgrid-resize').css("width", (totalPixels) + "px");
			$('#slider').attr("min", pxPerSec);
			$('#slider').val(pxPerSec);
		});


	}

	onLogout() {
		this.authService.logout();
	}

	sliderChange(event) {
		var zoomLevel = event.target.value;
		this.wavesurfer.zoom(zoomLevel);
	}

	displayWavFiles(response) {
		console.log("message: ", response.message);
		if (response.ok == false) {
			console.log("Error while fetching Wave files :", response.message);
		} else {
			console.log("Successfully fetched Wave files:", response.message);
			console.log("no. of wave files fetched:", response.text.length);
			this.text = response.text;
			this.curWaveName = response.text[0].recordingId;
			this.loadText();
		}
	}

	annotateThis() {
		this.status = "";
		this.fileChosen = true;
		const waveLen = this.text.length;
		let count = 0;
		console.log(`GO COUNT ${this.audioCount}`)

		this.callNextPrevText()
		this.loadText();

		// for (let i = 0; i < waveLen; i++) {
		// 	count = count + 1;
		// 	if (this.text[i].recordingNumber == 0) {
		// 		this.curWaveName = this.text[i].recordingId;
		// 		console.log("audio count in annotate if condition" + this.audioCount);
		// 		this.loadText();
		// 		break;
		// 	} else if ((count == this.text.length) && this.text[i].recordingNumber != this.audioCount) {
		// 		// console.log("i:", i, "and count:", count);
		// 		console.log("Please enter valid number");
		// 		this.openSnackBar("Please enter valid number", "", 4000);
		// 	}
		// }
	}

	callNextPrevText() {
		this.userName = this.authService.getUserName();

		this.waveService.getServerWaves(this.userName, this.audioCount).then((response: any) => {
			this.displayWavFiles(response);
		});
	}

	loadText() {
		$("#playPause").html("<i class='glyphicon glyphicon-play'></i> ");
		this.isPlaying = false;
		// this.audio.pause();
		this.clearRecordedData();
		if (this.text[0].status == "") {
			this.recordingStatus = "NOT RECORDED";
		} else if (this.text[0].status == "recorded") {
			this.recordingStatus = "RECORDED";
		} else if (this.text[0].status == "rejected") {
			this.recordingStatus = "REJECTED";
		} else {
			this.recordingStatus = "ACCEPTED";
		}
		// console.log("set isPlaying false inside else if condition");
		const waveLen = this.text.length;
		this.isLoaded = false;
		this.recordedTime = 0;
		if (waveLen - 1 > this.audioCount) {
			this.nextAudios = false;
		} else {
			this.nextAudios = true;
		}

		if (this.audioCount == 0) {
			this.previousAudios = true;
		} else {
			this.previousAudios = false;
		}

		let textFile = this.text[0].recordingId;
		// console.log("textFile inside loadText:", textFile);
		if (this.text[0].edited == true) {
			textFile = this.authService.BACKEND_URL + "/tamil/trans_files/" + textFile + ".txt";
			fetch(textFile)
				.then(response => response.text())
				.then(data => {
					$("textarea").val(data);
				}).catch((err) => {
					console.log("Unable to fetch corresponding text file");
					$("textarea").val("Unable to fetch corresponding text file");
					// document.getElementById('text').innerHTML = "Unable to fetch corresponding text file";
				})
		} else {
			$("textarea").val(this.text[0].originalText);
		}

		if (this.text[0].status == "recorded" || this.text[0].status == "accepted" || this.text[0].status == "rejected") {
			let audioFile = textFile.replace(".txt", ".wav");
			audioFile = audioFile.replace("/trans_files/", "/audio_files/");
			this.recordedTime = this.text[0].audioDuration;
			this.loadAudio(audioFile, this.recordingStatus);
		} else {
			this.loadAudio(null, "NOT RECORDED");
		}
	}

	loadAudio(audioFile, recordingStatus = "NOT RECORDED") {
		// console.log("Load Audio");
		// console.log("audio count in loadAudio :: " + this.audioCount);
		// this.audioSource = audioFile;
		// this.audio = new Audio();
		// console.log("this.audioSource:", this.audioSource);
		console.log(recordingStatus)
		if (recordingStatus === "NOT RECORDED") {
			this.isLoaded = false;
			$("#waveform").css("display", "none");
			$("#waveform-timeline").css("display", "none");
			// this.wavesurfer.load(audioFile);
		} else {
			this.isLoaded = true;
			$("#waveform").css("display", "block");
			$("#waveform-timeline").css("display", "block");
			this.wavesurfer.load(audioFile);
		}
		return;
	}


	previousAudio() {
		// console.log("previous audio");

		this.audioCount--;
		this.callNextPrevText()

		this.curWaveName = this.text[0].recordingId;
		// console.log("audio name in previous :: " + this.curWaveName);
		this.loadText();
	}

	nextAudio() {
		// console.log("next Audio");
		this.audioCount++;
		this.callNextPrevText()

		this.curWaveName = this.text[0].recordingId;
		// console.log("audio name in next :: " + this.curWaveName)
		this.loadText();
	}

	calcPercent(start, end) {
		var Percentage = ((end - start) / this.soundSeconds * 100).toFixed(3);
		return Percentage;
	}

	importFile(event) {
		// console.log("event.target.files: ", event.target.files);
		var filesToBeUploaded = (event.target as HTMLInputElement).files;
		// var theFiles = event.target.files;

		this.waveService.uploadText(filesToBeUploaded).then((result) => {
			console.log("Upload result: ", result);
			this.openSnackBar(result.message, "", 4000);
		});
	}

	saveText() {
		this.waveService.updateText(this.curWaveName, $("#text").val());
	}

	goToText() {
		console.log("go to text:", this.audioCount);
		this.annotateThis();
	}

	openSnackBar(message: string, action: string, duration) {
		this._snackBar.open(message, action, {
			duration: duration,
		});
	}

}